import React from 'react'
import { Container, Typography, TooltipV2 } from '@cleartrip/ct-design-components'
import CheckInLuggage from '@/assets/icons/CheckInLuggage'
import CabinLuggage from '@/assets/icons/CabinLuggage'
import { isEmpty } from '@/utils/general/browserHelper'
import { Stencil } from '@/components/common/Stencil'
import { replacePlaceholders } from '@/utils'
import { useAppSelector } from '@/redux/store/hooks'
import { getSrpSearchData } from '@/redux/slices/srpSlice'
import { BENEFIT_NOT_INCLUDED } from '@/constants/fareFamily'

const BaggageInfo = ({ baggageData = {}, isBaggageLoading = false }) => {
    const { isServicesLoading } = useAppSelector(getSrpSearchData)
    let { benefitList = [] } = baggageData

    const getBaggageString = (baggageType: 'checkin' | 'cabin') => {
        let benefitData =
            benefitList.find((benefit = {}) => {
                let benefitType = baggageType === 'checkin' ? 'CHECK_IN_BAGGAGE' : 'HAND_BAGGAGE'
                return benefit.benefitType === benefitType
            }) || {}
        let { details: { paxWiseBaggage = {} } = {} } = benefitData || {}
        let baggageInfo = paxWiseBaggage?.ADT || {}
        let { piece = 0, unit = '', weight = 0, text = '' } = baggageInfo
        const icon = baggageType === 'checkin' ? <CheckInLuggage /> : <CabinLuggage />
        const defaultWeight = baggageType === 'checkin' ? 23 : 7
        if (isEmpty(baggageInfo)) {
            if (isBaggageLoading || isServicesLoading) {
                return <Stencil shimmer={true} height="16px" width="120px" className="ml-2" />
            } else {
                return (
                    <Typography variant="L1" className="ml-1" color="alert">
                        Failed to load
                    </Typography>
                )
            }
        }
        if (piece > 0 && weight > 0) {
            return (
                <>
                    <Container className="flex">
                        <Typography variant="B1" className="ml-1">
                            {piece}
                        </Typography>
                        <Container className="ml-2 mr-1" style={{ height: '16px', marginTop: '2px' }}>
                            {icon}
                        </Container>
                        <Typography variant="B1" className="ml-1">{`x ${weight} ${unit}/ Adult`}</Typography>
                    </Container>
                </>
            )
        } else if (weight > 0 && unit) {
            return (
                <Container className="flex">
                    <Typography variant="B1" className="ml-1">{`${weight} ${unit} / Adult`}</Typography>
                </Container>
            )
        } else if (piece > 0) {
            return (
                <Container className="flex">
                    <Typography variant="B1" className="ml-1">
                        {piece}
                    </Typography>
                    <Container className="ml-2 mr-1" style={{ height: '16px', marginTop: '2px' }}>
                        {icon}
                    </Container>
                    <Typography variant="B1" className="ml-1">{`x ${defaultWeight} kg / Adult`}</Typography>
                </Container>
            )
        } else if (piece === 0 && weight === 0) {
            return (
                <Typography className='ml-1' color='warning' variant="B1">
                    {BENEFIT_NOT_INCLUDED}
                </Typography>
            )
        }
        return (
            <Container className="flex">
                <Typography variant="B1" className="ml-1">
                    {text}
                </Typography>
                <Typography variant="B1" className="ml-1">
                    {'/ Adult'}
                </Typography>
            </Container>
        )
    }
    return (
        <Container className="px-6 pt-4">
            <Container className="br-12 ba-solid bc-line-500 p-4">
                <Typography variant="HM3" className="mb-4">
                    Baggage Information:
                </Typography>
                {/*{!isEmpty(text) ? (
                    <TooltipV2
                        position="top"
                        width={"157px"}
                        labelContainer={
                            <Typography variant="HM3" className="c-pointer" colorCode="#36c">
                                View baggage policy
                            </Typography>
                        }
                    >
                        <Typography variant="P3">{freeText}</Typography>
                    </TooltipV2>
                ) : (*/}
                <Container className="flex" style={{ gap: '36px' }}>
                    <Container className="flex">
                        <Typography variant="B1" color="subheading">
                            Check-in:
                        </Typography>
                        <Typography variant="B1">{getBaggageString('checkin')}</Typography>
                    </Container>
                    <Container className="flex">
                        <Typography variant="B1" color="subheading">
                            Cabin:
                        </Typography>
                        <Typography variant="B1">{getBaggageString('cabin')}</Typography>
                    </Container>
                </Container>
                {/*})}*/}
            </Container>
        </Container>
    )
}

export default BaggageInfo
